import reducers from "./EkgSearchReducers";

export default reducers;
